
<template>
  <div>

     <md-table>
          <md-table-row>
              <md-table-head>Tid</md-table-head>
              <md-table-head>Criação</md-table-head>               
              <md-table-head>Cliente</md-table-head>
              <md-table-head>Valor</md-table-head>
              <md-table-head>Message</md-table-head>
              <md-table-head></md-table-head>
          </md-table-row>

          <md-table-row v-for="item in data" :key="item.id">
              <md-table-cell>{{ item.transaction.tid }}</md-table-cell>
              <md-table-cell>{{ item.created_at }}</md-table-cell>               
              <md-table-cell>{{ item.customer.name }}</md-table-cell>
              <md-table-cell>{{ item.amount }}</md-table-cell>
              <md-table-cell>{{ item.transaction.message }}</md-table-cell>
              <md-table-cell>
                    <md-button class="md-raised md-accent" @click="cancelTransaction(item)">Cancelar</md-button>
              </md-table-cell>
      </md-table-row>
    </md-table>          
  </div>
</template>

<script>


import http from '@/http';
 
export default {
  props:{
      data: Array
  },
  methods:{
    cancelTransaction(item){

      if(!confirm("Deseja cancelar?")){
         return false
       }
       
       const url = `/transaction/${item.transaction.tid}/cancel`;

       http.put(url).then( response =>{
              
              if(response.status == 204){
                 this.$notify({ group:"notify", text: 'Cancelado com sucesso', type:"success", });
              }
               
              }).catch( err =>{
                  
                  this.$notify({ group:"notify", text: err, type:"error", });

        });

       

    }
  }
};
</script>
